import { Card, Flex, Text } from '@servicetitan/anvil2';
import { Calculation } from '@servicetitan/financing-api-client';
import { formatCurrency } from '@servicetitan/financing-utils-shared';
import { PlanTags } from '@servicetitan/financing-plans-shared';
import { PrequalificationDecisionDataStore } from './PrequalificationDecisionDataStore';
import { PrequalificationDetails } from './PrequalificationDetails';

export const ApprovedPlans = () => {
    const { prequalDecisionData } = PrequalificationDecisionDataStore.useStore();

    const { approvedPlans, approvedAmount } = prequalDecisionData ?? {};

    const renderPlanItem = (plan: Calculation) => {
        return (
            <Card key={plan.planNumber} flexDirection="column" gap="3">
                <PlanTags plan={plan} />
                <Flex gap="3" wrap="wrap">
                    <div style={{ minWidth: '200px' }}>
                        <Text variant="eyebrow">Plan Number</Text>
                        <Text>{plan.planNumber}</Text>
                    </div>
                    <div style={{ minWidth: '200px' }}>
                        <Text variant="eyebrow">Approved Amount</Text>
                        <Text>{formatCurrency(approvedAmount ?? 0)}</Text>
                    </div>
                    <div style={{ minWidth: '200px' }}>
                        <Text variant="eyebrow">APR</Text>
                        <Text>{plan.defaultRate}%</Text>
                    </div>
                    <div style={{ minWidth: '200px' }}>
                        <Text variant="eyebrow">Term</Text>
                        <Text>{plan.defaultTerms} months</Text>
                    </div>
                    <div style={{ minWidth: '200px' }}>
                        <Text variant="eyebrow">Monthly Payment</Text>
                        <Text>{formatCurrency(plan.defaultMonthlyPayment)}</Text>
                    </div>
                </Flex>
                <div>
                    <Text variant="eyebrow">Description</Text>
                    <Text>{plan.displayDescription ?? plan.description}</Text>
                </div>
            </Card>
        );
    };

    return (
        <div>
            <Flex
                direction="column"
                gap="4"
                style={{ maxWidth: '845px', width: '100%', marginBottom: '40px' }}
            >
                {/* Prequalification Summary */}
                <PrequalificationDetails />

                {/* Approved Plans List */}
                {approvedPlans && approvedPlans.length > 0 && (
                    <Flex direction="column" gap="3">
                        <Text variant="headline" el="h2" size="small">
                            Approved Plans
                        </Text>
                        {approvedPlans.map(plan => renderPlanItem(plan))}
                    </Flex>
                )}
            </Flex>
        </div>
    );
};
